export default __webpack_public_path__ + "0faf0632169e83373ac14d3a12ca6678.webp";